import { render, staticRenderFns } from "./perimetroCefalicoNinas.vue?vue&type=template&id=19380d8e&scoped=true"
import script from "./perimetroCefalicoNinas.vue?vue&type=script&lang=js"
export * from "./perimetroCefalicoNinas.vue?vue&type=script&lang=js"
import style0 from "./perimetroCefalicoNinas.vue?vue&type=style&index=0&id=19380d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19380d8e",
  null
  
)

export default component.exports